import { OutboundCallSummarySchema } from '@nava/interviews-data-contracts';
import { z } from 'zod';
export const BackofficeInterviewLinkSchema = z.object({
    url: z.string().url().nullable(),
    hostname: z.string().nullable(),
    options: z.array(z.object({
        hostname: z.string(),
        kind: z.enum(['standard', 'organization_slug', 'custom']),
        url: z.string().url(),
    })),
    canChangeHostname: z.boolean(),
});
/** Explicit composition of the interviews-owned safe transport projection. */
export const BackofficeOutboundCallSchema = OutboundCallSummarySchema;
export { ExperienceProfileInputSchema, ExperienceProfileUpdateSchema, ExperienceProfileSchema, ExperienceProfileListSchema, ExperienceDefaultsSchema, } from '@nava/participant-experience-data-contracts';
export { ExperienceBindingSchema } from '@nava/research-data-contracts';
const BackofficeHostnameDefaultSchema = z.object({
    value: z.string(),
    hostname: z.string(),
    options: z.array(z.object({ value: z.string(), hostname: z.string() })),
});
export const BackofficeHostnameDefaultsSchema = z.object({
    insights: BackofficeHostnameDefaultSchema,
    customer_success: BackofficeHostnameDefaultSchema,
});
export { StudyPageContentSchema, StudyPageContentPatchSchema, } from '@nava/research-data-contracts';
//# sourceMappingURL=index.js.map